import React from 'react';

export default function Footer({ brand, onBackToTop }) {
  return (
    <footer className="footer">
      <div className="footer-inner">
        <div>{brand}</div>
        <button className="footer-link" onClick={onBackToTop} type="button">
          Back to top
        </button>
      </div>
    </footer>
  );
}

